import React, { useEffect, useState } from "react";
import { CategoryApiResponseModel as IntegrationsApiResponseModel, CategoryDataModel } from "../models/category-api-response.model";
import { fetchBonkDataIntegrations, fetchMeta } from "../services/strapi.service";
import IntegrationsJson from "../assets/integrations/integrations.json";
import { DEFAULT_META_VALUES, MetaModel } from "../models/meta.model";

type DataProviderProps = {
	categories: CategoryDataModel[] | undefined;
	integrationsCount: number;
	meta: MetaModel[] | undefined;
};

export const DataContext = React.createContext({} as DataProviderProps);

export const DataProvider = ({ children }: any) => {
	const [categories, setCategories] = useState<CategoryDataModel[]>();
	const [meta, setMeta] = useState<MetaModel[]>();
	const [integrationsCount, setIntegrationsCount] = useState<number>(0);

	async function fetchData() {
		// INTEGRATIONS
		let integrations: IntegrationsApiResponseModel | undefined = await fetchBonkDataIntegrations();
		// data = undefined; //(for testing purposes)
		if (!integrations) {
			integrations = IntegrationsJson as IntegrationsApiResponseModel;
		}

		setCategories(integrations.data.sort((a, b) => a.attributes.sort - b.attributes.sort));

		//META
		let metaData: MetaModel[] | undefined = await fetchMeta();
		if (!metaData) {
			metaData = DEFAULT_META_VALUES
		}
		setMeta(metaData);
	}

	useEffect(() => {
		fetchData();
	}, []);

	useEffect(() => {
		if (categories) {
			setIntegrationsCount(
				categories.map((category) => category.attributes.integrations.data.filter((o) => o.attributes.active === true).length).reduce((a, b) => a + b)
			);
		}
	}, [categories]);

	return <DataContext.Provider value={{ categories: categories, integrationsCount: integrationsCount, meta: meta }}>{children}</DataContext.Provider>;
};
